import { useEffect, useState } from 'react'
import apiInstance from '../apiAuth'
import * as constants from "../constants";
import { useAuth } from './AuthContext';

const UserInfo = () => {
	const auth_user = useAuth();
	const local_key = localStorage.getItem("authToken")
	const [user_data, set_user_data] = useState({})
	const [active_role, set_active_role] = useState(null);

	const [local_user, setLocalUser] = useState(null);
	const getLocalUser = () => {
		const apiUrl = `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/users-viewset?show_details=${true}&current_user=${true}&active_role=${localStorage.getItem("activeRole")}`;
		apiInstance.get(apiUrl, { headers: { "Authorization": `Token ${local_key}` } })
			.then((response) => {
				const user = response?.data?.data?.[0];
				if (user) {
					setLocalUser(user);
				}
			})
			.catch((e) => console.log('something went wrong :(', e));
	}

	useEffect(() => {
		if (!user_data || Object.keys(user_data).length === 0) {
			getLocalUser();
		}
	}, [user_data])

	useEffect(() => {
		const storedRole = localStorage.getItem("activeRole");
		if (!active_role && user_data && user_data?.role?.length > 0) {
			if (storedRole && user_data?.role.includes(storedRole)) {
				set_active_role(storedRole);
			} else {
				set_active_role(user_data?.role?.[0]);
			}
		}
	}, [user_data]);

	useEffect(() => {
		const switchActiveRole = (role) => {
			set_active_role(role);
			localStorage.setItem("activeRole", role); // persist role in local storage
			setLocalUser((prev) => {
				const updatedUser = { ...prev, active_role: role };
				set_user_data((prevData) => ({
					...prevData,
					active_role: role,
					switchActiveRole,
				}));
				return updatedUser;
			});
		};

		var active_role_ = active_role || local_user?.active_role;
		if (!auth_user.user || Object.keys(auth_user.user).length === 0) {
			if (local_key && local_user) {
				var pk = local_user.pk;
				var user_name = local_user.username;
				var f_name = local_user.first_name;
				var l_name = local_user.last_name;
				var u_email = local_user.email;
				var u_role = local_user?.role?.map((role) => role.role_name);
				var u_perm = local_user.permissions;
				var join_date = local_user.joined_date;
				var modify_date = local_user.update_date;
				var is_active = local_user.is_active;
				var is_staff = local_user.is_staff;
				var is_superuser = local_user.is_superuser;
				var role_status = local_user?.role?.[0]?.is_active;
				var is_pm = local_user?.is_pm || false;
				var has_outreach_assignments = local_user?.has_outreach_assignments || false;
				set_user_data({
					pk: pk, username: user_name, first_name: f_name,
					last_name: l_name, role: u_role, permissions: u_perm, email: u_email,
					joining_data: join_date, profile_update_date: modify_date, is_active: is_active,
					is_staff: is_staff, is_superuser: is_superuser, role_status: role_status,
					is_pm: is_pm, has_outreach_assignments: has_outreach_assignments,
					switchActiveRole, active_role: active_role_
				})

			}
		}
		else {
			set_user_data({ 
				...auth_user.user, 
				is_superuser: auth_user.user?.is_superuser,
				switchActiveRole, 
				active_role: active_role_ 
			})
		}

	}, [active_role, auth_user, local_user])

	return user_data

}
export default UserInfo